var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showRibbon)?_c('div',{staticClass:"petstar-ribbon"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"petstar-ribbon-content"},[_c('div',[_vm._v("POWERED BY")]),_c('div',[_vm._v("Petstar")])])
}]

export { render, staticRenderFns }